import React from 'react';
import { ScrollToContainer } from '../styled';
import { ListenerSupportSection } from './ListenerSupportSection';
import { MonetizationSection } from './MonetizationSection';

export function SponsorshipsSection() {
  return (
    <ScrollToContainer id="sponsorships">
      <MonetizationSection />
      <ListenerSupportSection />
    </ScrollToContainer>
  );
}
